import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';

export default function CGV() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#0a0a0f] text-white min-h-screen">
      <Navbar scrolled={true} />
      
      <div className="pt-32 pb-20 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 bg-gradient-to-r from-violet-400 to-blue-400 bg-clip-text text-transparent">
            Conditions Générales de Vente
          </h1>

          <div className="space-y-8 text-gray-300">
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">1. Présentation de la société</h2>
              <p className="mb-3">Les présentes Conditions Générales de Vente (ci-après « CGV ») régissent les relations contractuelles entre :</p>
              <div className="bg-white/5 border border-white/10 rounded-lg p-6 space-y-2">
                <p><strong className="text-white">AI Exécutif Assistant</strong></p>
                <p>Entreprise individuelle : Heuby Jennifer</p>
                <p>Adresse : 50 avenue des Champs-Élysées, 75018 Paris, France</p>
                <p>SIREN : 793 328 204</p>
                <p>Email : <a href="mailto:contact@assistantexecutifai.com" className="text-violet-400 hover:text-violet-300 transition-colors">contact@assistantexecutifai.com</a></p>
                <p>Téléphone : <a href="tel:+33970703990" className="text-violet-400 hover:text-violet-300 transition-colors">+33 9 70 70 39 90</a></p>
              </div>
              <p className="mt-3">Et toute personne morale ou physique agissant à titre professionnel (ci-après « le Client »).</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">2. Objet</h2>
              <p className="mb-3">AI Exécutif Assistant propose des prestations de services d'assistance exécutive basée sur l'intelligence artificielle, incluant notamment :</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Déploiement d'agents IA personnalisés</li>
                <li>Automatisation de tâches administratives, organisationnelles et de communication</li>
                <li>Conseil, paramétrage, maintenance et optimisation d'agents IA</li>
                <li>Accompagnement stratégique et opérationnel</li>
              </ul>
              <p className="mt-3">Les services sont fournis exclusivement à titre professionnel (B2B).</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">3. Acceptation des CGV</h2>
              <p>Toute commande, réservation de rendez-vous, signature de devis ou paiement implique l'acceptation pleine et entière des présentes CGV, sans réserve.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">4. Description des services</h2>
              <p>Les services sont fournis sur mesure, selon les besoins exprimés par le Client lors de la phase d'analyse et d'onboarding.</p>
              <p className="mt-3">AI Exécutif Assistant s'engage à mettre en œuvre tous les moyens nécessaires pour fournir une prestation conforme, sans obligation de résultat chiffré.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">5. Commande et contractualisation</h2>
              <p className="mb-3">La commande devient ferme et définitive après :</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>validation écrite du devis ou de l'offre,</li>
                <li>et/ou paiement total ou partiel de la prestation.</li>
              </ul>
              <p className="mt-3">AI Exécutif Assistant se réserve le droit de refuser toute commande en cas de non-paiement antérieur ou de demande non conforme à son positionnement.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">6. Tarifs</h2>
              <p className="mb-3">Les prix sont exprimés en euros (€), hors taxes (HT), sauf mention contraire.</p>
              <p className="mb-3">Les prestations peuvent inclure :</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>des frais de setup / déploiement,</li>
                <li>un abonnement mensuel,</li>
                <li>des frais de maintenance ou d'évolution.</li>
              </ul>
              <p className="mt-3">Les tarifs sont communiqués au Client avant toute validation.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">7. Modalités de paiement</h2>
              <p className="mb-3">Le paiement s'effectue :</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>par virement bancaire,</li>
                <li>carte bancaire,</li>
                <li>ou tout autre moyen précisé lors de la commande.</li>
              </ul>
              <p className="mt-3">Sauf indication contraire :</p>
              <ul className="list-disc list-inside space-y-2 ml-4 mt-2">
                <li>les prestations de setup sont payables avant démarrage,</li>
                <li>les abonnements sont payables mensuellement à terme échu ou à échoir.</li>
              </ul>
              <p className="mt-3">Tout retard de paiement pourra entraîner la suspension immédiate du service.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">8. Droit de rétractation</h2>
              <p>Conformément à l'article L221-3 du Code de la consommation, aucun droit de rétractation ne s'applique aux prestations fournies à des professionnels, surtout lorsque l'exécution a commencé avec l'accord du Client.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">9. Confidentialité</h2>
              <p>AI Exécutif Assistant s'engage à respecter la confidentialité des informations communiquées par le Client dans le cadre de la prestation.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">10. Responsabilité</h2>
              <p>AI Exécutif Assistant met en œuvre tous les moyens pour assurer la qualité de ses services. Sa responsabilité ne pourra être engagée qu'en cas de faute prouvée et sera limitée au montant des sommes effectivement versées par le Client.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">11. Résiliation</h2>
              <p>Le Client peut résilier son abonnement à tout moment, sous réserve d'un préavis de 30 jours. Aucun remboursement ne sera effectué pour la période en cours.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">12. Propriété intellectuelle</h2>
              <p>Tous les éléments fournis par AI Exécutif Assistant (agents IA, configurations, documentations) restent sa propriété exclusive. Le Client dispose d'un droit d'utilisation dans le cadre de la prestation.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">13. Données personnelles</h2>
              <p>Le traitement des données personnelles est régi par notre Politique de confidentialité, conforme au RGPD.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">14. Droit applicable et litiges</h2>
              <p>Les présentes CGV sont soumises au droit français. En cas de litige, les parties s'efforceront de trouver une solution amiable. À défaut, les tribunaux compétents de Paris seront seuls compétents.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">15. Modifications</h2>
              <p>AI Exécutif Assistant se réserve le droit de modifier les présentes CGV à tout moment. Les CGV applicables sont celles en vigueur à la date de la commande.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Contact</h2>
              <p>Pour toute question concernant ces CGV :</p>
              <p className="mt-2">📧 <a href="mailto:contact@assistantexecutifai.com" className="text-violet-400 hover:text-violet-300 transition-colors">contact@assistantexecutifai.com</a></p>
              <p>📞 <a href="tel:+33970703990" className="text-violet-400 hover:text-violet-300 transition-colors">+33 9 70 70 39 90</a></p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}